import * as Yup from 'yup'
import {
  customAudiencesInitialValues,
  customAudiencesValidation
} from '../../../../../ReusableFormFields/Audiences/AudiencesFields/fields'

export const dv360AudiencesInitialValues = {
  // AUDIENCES
  ...customAudiencesInitialValues
}

export const validationSchema = Yup.object({
  // AUDIENCES
  ...customAudiencesValidation
})
